import { Component, OnInit } from '@angular/core';
import { Documento, GeoJson } from '../map';
import { AppService } from '../app.service';
import { HttpClient, HttpRequest } from '@angular/common/http';


@Component({
  selector: 'add-content',
  templateUrl: './add-content.component.html',
  styleUrls: ['./add-content.component.css']
})
export class AddContentComponent implements OnInit {

  categories = ['bioacustica', 'social', 'urbano', 'natural'];

  document = new Documento(1,new GeoJson([0,0]),'', '', '', this.categories[0], null);

  submitted = false;
  loading = false;

  constructor(
    public appService : AppService,
    public http: HttpClient
  ) {
  }

  onFileChange(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        var r = reader.result
        this.document.file = r;
      }
    }
  }

  public sendEmail(document:Documento):void {
    const formData: FormData = new FormData();
    formData.append('file', document.file, 'test')
    formData.append('id',(document.id).toString())
    formData.append('title', document.title)
    formData.append('author', document.author)
    formData.append('coord',JSON.stringify(document.coord))
    formData.append('description', document.description)
    formData.append('category', document.category)

    const req = new HttpRequest('POST', 'http://localhost:3000/soinumapa/add', formData)
    this.http.request(req)
    .subscribe(
      res => {
      }
    )
    //
    // this.http.post("http://localhost:3000/soinumapa/add",formData)
    // .subscribe(
    //   res => {
    //     this.loading=false;
    //     this.appService.add(res['result'],true);
    //     console.log(res);
    //   }
    // );
  }

  onSubmit() {
    this.document.setCoord(this.appService.markers)
    //console.log(this.document);
    this.sendEmail(this.document);
    this.loading = true;
    this.submitted = true
  }

  ngOnInit() {
    this.document.setCoord(this.appService.markers)
  }

  get diagnostic() { return JSON.stringify(this.document) }

}

/* documentatoin */
/*
https://nehalist.io/uploading-files-in-angular2/
*/



// WEBPACK FOOTER //
// ./src/app/add-content/add-content.component.ts